import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pessoa-vinculada-info',
  templateUrl: './pessoa-vinculada-info.component.html',
  styleUrls: ['./pessoa-vinculada-info.component.scss'],
})
export class PessoaVinculadaInfoComponent {
  @Input() pessoa: any;
}
